/** First letters of the first two words, for an avatar with no photo. */
export function initialsOf(name: string | undefined | null): string {
  if (!name) return ''
  return name
    .split(' ')
    .filter(Boolean)
    .map(part => part[0]?.toUpperCase() ?? '')
    .slice(0, 2)
    .join('')
}
